import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, ViewChild } from '@angular/core';
import { ConfigTableRow, DialerConfig, DialerMonitorComponent, RootTest } from 'dialer';
import { BsModalService } from 'ngx-bootstrap/modal';
import { asyncScheduler } from 'rxjs';
import { AppState } from '../../core';
import { DriveTestPoint, DriveTestPointSeq, PathTestPoint, PathTestPointSeq } from '../../core/models';
import { DialerClientService } from '../../core/services/dialer-client-service';

@Component({
  selector: 'app-dialer-client-monitor',
  templateUrl: './dialer-client-monitor.component.html',
  styleUrls: ['./dialer-client-monitor.component.scss']
})
export class DialerClientMonitorComponent implements AfterViewInit, OnDestroy {

  errorMsg = "";
  monitorRefresh$ = new EventEmitter<void>()

  @Input('pathTestPoint') set setPathTestPoint(tp: PathTestPoint | DriveTestPoint) {
    this.pathTestPoint = tp
  }

  @Input('seq') set inputSeq( seq: PathTestPointSeq | DriveTestPointSeq ) {
    this.pathTestPointSeq = seq
  }

  buildConfigFn : () => DialerConfig

  @ViewChild('dialerMonitor') set dialerConfig( c : DialerMonitorComponent ) {
    if ( c ) {
      this.buildConfigFn = c.buildConfig
      c.handleError = (error) => {
        console.error(error);
        if ( error?.lostTest ) {
          this.appState.notifyWarning(error.message,this.dialerClientService,3);
        } else {
          this.errorMsg = error?.message || `Error: ${error}`;
        }
        this.appState.publishError(error,this);
      }
    } else {
      this.buildConfigFn = null
    }
  }

  pathTestPoint: PathTestPoint | DriveTestPoint
  pathTestPointSeq: PathTestPointSeq | DriveTestPointSeq
  rootTestAcceptFilter: (rootTest: RootTest) => boolean = null
  monitorRowFilter: (row: ConfigTableRow) => boolean = null

  public hideDisabledMonitorRows = true


  constructor(
    public dialerClientService: DialerClientService,
    protected modalService: BsModalService,
    protected appState: AppState) {
  }

  ngAfterViewInit(): void {
    this.hideDisabledMonitorRows = this.dialerClientService.dialerConfigService.loadHideDisabledRowsPreference()
    asyncScheduler.schedule( this.updateMonitorFilter )
  }

  ngOnDestroy() {
  }

  updateMonitorFilter = () => {
    this.dialerClientService.dialerConfigService.saveHideDisabledRowsPreference(this.hideDisabledMonitorRows)
    if (this.hideDisabledMonitorRows) {
      this.monitorRowFilter = (row: ConfigTableRow) => row.configEntry.enabled
    } else {
      this.monitorRowFilter = null
    }
    console.log('this.hideDisabledMonitorRows = ' + this.hideDisabledMonitorRows)
  }
}
